import {
  EventStatusSchema,
  type EventStatus as GeneratedEventStatus
} from '~/services/api/generated'

// Mirrors backend App\Enums\Event\EventStatus

export type EventStatus = GeneratedEventStatus

export const EventStatus = {
  UPCOMING: EventStatusSchema.enum.upcoming,
  ACTIVE: EventStatusSchema.enum.active,
  PAST: EventStatusSchema.enum.past,
  CANCELLED: EventStatusSchema.enum.cancelled
} satisfies Record<string, GeneratedEventStatus>

export const EventStatusValues: readonly GeneratedEventStatus[] = [
  EventStatusSchema.enum.upcoming,
  EventStatusSchema.enum.active,
  EventStatusSchema.enum.past,
  EventStatusSchema.enum.cancelled
]
